import { render } from "./ProductDetails.vue?vue&type=template&id=3792a9e4&scoped=true"
import script from "../js/product-details.js?vue&type=script&lang=js&external"
export * from "../js/product-details.js?vue&type=script&lang=js&external"

import "./ProductDetails.vue?vue&type=style&index=0&id=3792a9e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3792a9e4"]])

export default __exports__